import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/containers/Main'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import HeaderCustomerSelect from 'containers/HeaderCustomerSelect'
import InputWrapper from 'shared/components/InputWrapper'
import resReportConfiguration from './resolvers/resReportConfiguration'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import submitForm from './utils/submitForm'
import SelectWrapper from 'shared/components/SelectWrapper'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import prepareSubmitForm from './utils/prepareSubmitForm'
import showCustomerSwitcher from 'utils/showCustomerSwitcher'

const ReportConfiguration: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const submitRef = React.createRef<HTMLButtonElement>()

  const [serviceStatuses, setServiceStatuses] = useState<any>([])
  const [sections, setSections] = useState<Array<any>>([])
  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})

  const navigate = useNavigate()

  const {
    control,
    register,
    getValues,
    handleSubmit,
    reset,
    setFocus,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resReportConfiguration,
  })

  useInit({
    reset,
    setDataLoaded,
    setShowOverlay,
    setServiceStatuses,
    setSections,
    setValue,
  })

  useFocusError({
    errors,
    setFocus,
  })

  const isAdmin: boolean = hasAnyRole([roles.admin, roles.superAdmin])

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      showMinimizedBarButton={true}
      headerInsert={
        showCustomerSwitcher() ? (
          <HeaderCustomerSelect
            setShowOverlay={setShowOverlay}
            handleCustomerChanged={(customer) => {
              setCurrentCustomer(customer)
              setShowOverlay(false)
            }}
          />
        ) : undefined
      }
      actionInsert={
        isAdmin && (
          <Button
            disabled={!dataLoaded}
            type='submit'
            name='save'
            className='btn-round btn-primary'
            onClick={() => {
              if (submitRef.current != null) {
                submitRef.current.click()
              }
            }}
          >
            Save
          </Button>
        )
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            setError,
            data,
            setShowOverlay,
            name: 'Report Configuration',
          }),
        )}
        id='main-form'
      >
        {Object.entries(sections).map(([key, sectionName]) => {
          const fieldName = 'section_' + key
          return (
            <InputWrapper key={key} label={sectionName as string} name={fieldName} errors={errors}>
              <SelectWrapper
                name={fieldName}
                control={control}
                options={serviceStatuses}
                optionLabel='name'
                optionValue='id'
                defaultValue={[]}
                placeholder='Select Service Status...'
                isMulti={true}
              />
            </InputWrapper>
          )
        })}

        <Button type='submit' name='save' ref={submitRef} className='d-none'></Button>
      </Form>
    </Layout>
  )
}

export default ReportConfiguration
